export enum TraderViewStatus {
  PendingApproval = 'pending_approval',
  PendingExecution = 'pending_execution',
  PendingRFQ = 'pending_rfq',
  ApprovalRequired = 'approval_required',
  RoutingRequired = 'routing_required',
  RFQResponseRequired = 'rfq_response_required',
  PartiallyRouted = 'partially_routed',
  Rejected = 'rejected',
  Filled = 'filled',
  Canceled = 'canceled',
}
